import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../utils/cn';

/** Card surface — elevated container for grouping content. */
export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        'bg-biz-surface-elevated text-biz-foreground',
        'border border-biz-border rounded-biz-card',
        'shadow-biz-sm',
        className,
      )}
      {...rest}
    />
  ),
);
Card.displayName = 'Card';

export const CardHeader = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        'px-biz-card py-biz-content-lg',
        'border-b border-biz-border',
        'flex items-center justify-between gap-biz-content-lg',
        className,
      )}
      {...rest}
    />
  ),
);
CardHeader.displayName = 'CardHeader';

export const CardBody = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div ref={ref} className={cn('px-biz-card py-biz-content-lg', className)} {...rest} />
  ),
);
CardBody.displayName = 'CardBody';

export const CardFooter = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        'px-biz-card py-biz-content-lg',
        'border-t border-biz-border',
        'flex items-center justify-end gap-biz-content-lg',
        className,
      )}
      {...rest}
    />
  ),
);
CardFooter.displayName = 'CardFooter';
